'use strict';

//var buyBox = require('plugin_buybox/product/detail');
var base = require('base/product/base');
var baseProductDetail = require('base/product/detail'),
    Promise = require('promise'),
    _ = require('lodash'),
    util = require('grocery/util'),
    page = require('grocery/page'),
    dialog = require('grocery/dialog'),
    minicart = require('grocery/minicart'),
    progress = require('grocery/progress'),
    carousel = require('grocery/carousel'),
    ajax = require('grocery/ajax'),
    //productStoreInventory = require('../../storeinventory/product'),
    //tooltip = require('../../tooltip'),
    //availability = require('./availability'),
    //image = require('./image'),
    //productNav = require('./productNav'),
    //productSet = require('./productSet'),
    //variant = require('./variant'),
    favouritewidget = require('grocery/pages/favouritewidget'),
    promos = require('grocery/promos');


function getCookie(name) {
    const value = `; ${document.cookie}`;
    const parts = value.split(`; ${name}=`);
    if (parts.length === 2) return parts.pop().split(';').shift();
}

var cartToast = require('org_jau/components/cartToast');

/**
 * @description Make the AJAX request to add an item to cart
 * @param {Element} form The form element that contains the item quantity and ID data
 * @returns {Promise}
 */
function addItemToCart(form) {
    var $form = $(form),
        $qty = $form.find('input[name="quantity"], select[name="quantity"]');

    if ($qty.length === 0 || isNaN($qty.val()) || parseInt($qty.val(), 10) === 0 || Number($qty.val()) < 0) {
        $qty.val('1');
    }

    return Promise.resolve($.ajax({
        type: 'POST',
        url: util.ajaxUrl(Urls.addProduct),
        data: $form.serialize()
    })).then(function (response) {
        // handle error in the response
        if (response.error) {
            throw new Error(response.error);
        } else {
            return response;
        }
    });
}

/**
 * @description Handler to handle the add to cart event
 */
function addToCart (e) {
    e.preventDefault();
    if (!getCookie('dw_shippostalcode')) {
        $('#popUpCep').slideDown();
        $('#popUpCep').modal('show'); //MOSTRA O MODAL DE CEP
    } else {
        var $form = $(this).closest('form');
        var pid = $(this).data('pid');
        var qty = 1; // quantity selection is not editable by the user until after 1 product is added, so start with 1.
        var productURL = util.ajaxUrl(Urls.getProductUrl + '?pid=' + pid);

        const jqXHR = $.ajax({
            type: 'POST',
            url: util.ajaxUrl(Urls.addProduct),
            data: $form.serialize()
        });

        jqXHR.done(function (response) {
            var $uuid = $form.find('input[name="uuid"]');
            if ($uuid.length > 0 && $uuid.val().length > 0) {
                page.refresh();
            } else {
                // do not close quickview if adding individual item that is part of product set
                // @TODO should notify the user some other way that the add action has completed successfully
                if (!$(this).hasClass('sub-product-item')) {
                    dialog.close();
                }
                // Update pdpAddToCartForm
                $.ajax({
                    url: productURL,
                    type:  'GET',
                    dataType: 'html',
                    success: function(data) {
                        var newPdpAddToCartForm = $(data).children('#pdpMain').find('#pdpAddToCartForm');
                        $('#pdpAddToCartForm').html(newPdpAddToCartForm.html());
                    }
                });
                // Update the miniCart
                $.ajax({
                    url: Urls.miniCart,
                    type:  'GET',
                    dataType: 'html',
                    success: function(data) {
                        minicart.show(data, !$('.mini-cart-empty').length);
                    }
                });
                $(document).trigger({
                    type: 'add-to-cart-pdp',
                    pid: pid,
                    quantity: qty,
                    source: 'pdp',
                    uuid: $uuid.val()
                });

                if (response && response.toastHtml) {
                    cartToast.show(response.toastHtml);
                }
            }
        });
    }
}


function addAllToCart(e) {
    e.preventDefault();
    var $productForms = $('#product-set-list').find('form').toArray();
    // We're popping the last array item (product) off so we can re-call addItemToCart() later with this alone
    // so that we're sure to have all the products in the last call
    var lastProduct = $productForms.pop();
    Promise
        .all(_.map($productForms, addItemToCart))
        .then(function () {
            dialog.close();

            // We have to call addItemToCart again with the last product so that we get a response with all the products in it
            addItemToCart(lastProduct).then(function (responses) {
                minicart.show(responses, !$('.mini-cart-empty').length);
            });
        });
}

function openAccordian() {
    if ($('.pdp-howto').length === 0 && $('.pdp-awards').length === 0) {
        $('.list-group .list-group-item:not(.d-md-none):first h4').toggleClass('collapsed').attr('aria-expanded', 'true');
        $('.list-group .list-group-item:not(.d-md-none):first .collapse').toggleClass('show');
    }
}

/**
 * @description Initialize event handlers on product detail page
 */
function initializeEvents () {
    var $pdpMain = $('#pdpMain');

    // Add to Wishlist and Add to Gift Registry links behaviors
    $pdpMain.on('click', '[data-action="gift-registry"]', function () {
        var data = util.getQueryStringParams($('.pdpForm').serialize());
        if (data.cartAction) {
            delete data.cartAction;
        }
        var url = util.appendParamsToUrl(this.href, data);
        this.setAttribute('href', url);
    });

    // product options
    $pdpMain.on('change', '.product-options select', function () {
        var salesPrice = $pdpMain.find('.product-add-to-cart .price-sales');
        var selectedItem = $(this).children().filter(':selected').first();
        salesPrice.text(selectedItem.data('combined'));
    });

    // prevent default behavior of thumbnail link and add this Button
    $pdpMain.on('click', '.thumbnail-link, .unselectable a', function (e) {
        e.preventDefault();
    });

    $('.tiles-carousel').slick({
        config: carousel.landing
    });

    // Add to Cart click handlers
    $(document).off('click', 'button.add-to-cart, button.add-to-cart-global');
    $(document).on('click', '.product-detail .add-to-cart', addToCart);
    $('#add-all-to-cart').on('click', addAllToCart);


    if (SitePreferences.STORE_PICKUP) {
        //productStoreInventory.init();
    }

    /**
     * Listen for the add-to-cart-pdp event and update minicart & PDP with the needed PLI data
     * @returns
     */
    $(document).on('add-to-cart-pdp', function (e) {

        const productLineItems = window.ProductLineItems;
        var suppressMinicart = false;

        for (var i in productLineItems) {
            const productLineItem = productLineItems[i];
            const promos = productLineItem.promoInfo;

            for (var j in promos) {
                const $productOffer = $('.product-offer[data-promo="' + promos[j].ID + '"]');

                if ($productOffer.length) {
                    $('.product-offers').attr('data-item-uuid', productLineItem.UUID);
                }
            }
        }

        promos.addPromoMessages();

        // TODO: Re-initialize the product ratings when implemented

        if (!suppressMinicart) {
            $(document).trigger({
                type: 'basketupdate',
                pid: e.pid,
                quantity: e.quantity,
                source: 'pdp',
                uuid: e.uuid
            });
        }
    });

    $(document).on('basketupdate.pdp', function (e) {
        var $content = $('#pdpAddToCartForm');
        if (window.location.href.indexOf('?pid=' + e.pid) >= 0) {
            if (isNaN(e.quantity) || e.quantity === 0 || (e.quantity === 1 && !$content.find('.quantity-container').length)) {
                progress.show($content);
                var params = {
                    Quantity: isNaN(e.quantity) ? '1' : e.quantity,
                    pid: e.pid,
                    format: 'ajax'
                };
                if (e.quantity === 0) {
                    // If going back to 0 just reset the whole PDP
                    $.ajax({
                        url: util.ajaxUrl(Urls.getProductUrl + '?pid=' + e.pid),
                        type:  'GET',
                        dataType: 'html',
                        success: function(data) {
                            var newPdp = $(data).children('#pdpMain');
                            $('#pdpMain').html(newPdp.html());
                        }
                    });
                } else {
                    const jqXHR = ajax.load({
                        url: util.appendParamsToUrl(window.Urls.pdpRefreshAddToBagQuantity, params),
                        target: $content
                    });

                    jqXHR.always(function () {
                        promos.addPromoMessages();
                        progress.hide();
                    });
                }
            }
        }
    });
    
    $('body').on('change', '.substituion-option', function (e) {
        e.preventDefault();
        var substituionOption = $('[id$=substitution-option] option:selected').val();
        $('input[name$=substitution]').val(substituionOption);
    });

}


function miniCartReportingUrl(url) {
    if (url) {
        $.ajax({
            url: url,
            method: 'GET',
            success: function () {
                // reporting urls hit on the server
            },
            error: function () {
                // no reporting urls hit on the server
            }
        });
    }
}

// TO DO  put this function in a util to be used by other scripts
function getQueryParams(qs) {
    qs = qs.split('+').join(' ');

    var params = {},
        tokens,
        re = /[?&]?([^=]+)=([^&]*)/g;

    while (tokens = re.exec(qs)) {
        params[decodeURIComponent(tokens[1])] = decodeURIComponent(tokens[2]);
    }

    return params;
}

module.exports = $.extend({}, baseProductDetail, {
    init: function () {
        openAccordian();
        favouritewidget.initAddToFavourite();
        promos.addPromoMessages();
        initializeEvents();
    },
    availability: baseProductDetail.availability,
    // addToCartmarketplace: buyBox.addToCartmarketplace,
    // updateAttributesAndDetails: buyBox.updateAttributesAndDetails,
    // showSpinner: buyBox.showSpinner,
    updateAttribute: function () {
        $('body').off('product:afterAttributeSelect').on('product:afterAttributeSelect', function (e, response) {
            if ($('.product-detail>.bundle-items').length) {
                response.container.data('pid', response.data.product.id);
                response.container.find('.product-id').text(response.data.product.id);
            } else if ($('.product-set-detail').eq(0)) {
                response.container.attr('data-pid', response.data.product.id);
                response.container.find("[data-pid]").attr('data-pid', response.data.product.id);
                response.container.find("#pid").attr('value', response.data.product.id);
                response.container.find("#add-to-cart").attr('data-pid', response.data.product.id);
                response.container.find('.product-id').text(response.data.product.id);
            } else {
                $('.product-id').text(response.data.product.id);
                $('.product-detail:not(".bundle-item")').data('pid', response.data.product.id);
            }
            response.container.find('.sellers').empty().html(response.data.product.marketplaceHtml);
            response.container.find('.soldBy').empty().html(response.data.product.soldByHtml);
        });
    },
    // updateAddToCart: buyBox.updateAddToCart,
    // updateAvailability: buyBox.updateAvailability,
    // sizeChart: buyBox.sizeChart,
    // copyProductLink: buyBox.copyProductLink,
    // preSelectVariant: buyBox.preSelectVariant,
    focusChooseBonusProductModal: base.focusChooseBonusProductModal(),
    // viewShippingCosts: buyBox.viewShippingCosts,
    // changeSortOrder: buyBox.changeSortOrder,
    // scrollToBuyBox: buyBox.scrollToBuyBox
});
